import React, { useEffect, useState } from "react";

export default function AdminPages() {
  const [pages, setPages] = useState([]);
  const [newPage, setNewPage] = useState("");

  const load = async () => {
    const res = await fetch("/api/pages", { credentials: "include" });
    setPages(await res.json());
  };

  useEffect(() => {
    load();
  }, []);

  const addPage = async () => {
    if (!newPage.trim()) return;

    const res = await fetch("/api/pages", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slug: newPage }),
    });

    if (res.ok) {
      setNewPage("");
      load();
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this page and all its content?")) return;

    const res = await fetch(`/api/pages/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (res.ok) {
      setPages(pages.filter(p => p.id !== id));
    }
  };

  return (
    <div>
      <h3>Pages</h3>

      <div className="d-flex mb-3">
        <input
          className="form-control me-2"
          placeholder="page slug (e.g. about)"
          value={newPage}
          onChange={e => setNewPage(e.target.value)}
        />
        <button className="btn btn-success" onClick={addPage}>
          Add Page
        </button>
      </div>

      <ul className="list-group">
        {pages.map(p => (
          <li key={p.id} className="list-group-item d-flex justify-content-between">
            <span>{p.slug}</span>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => remove(p.id)}
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
